import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';
import { ShopState, FetchShops } from '../../../_state/shop/shop.state';
import { RoutesEnum } from '../enums/routes.enum';
import { environment } from '../../../../environments/environment';
import { isVatEligibleRegion } from '../../../shared/constants/vat-regions';

/**
 * Shop-level route gate for VAT Settings. This is UX/display protection only:
 * backend ENABLE_VAT_SETTINGS + FeatureFlagGuard remain authoritative.
 */
export const vatSettingsAccessGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const store = inject(Store);
  const router = inject(Router);
  const deny = (): UrlTree => router.parseUrl(RoutesEnum.SETTINGS);

  if (!environment.enableVatSettings) return deny();

  let active = store.selectSnapshot(ShopState.activeShop);
  if (!active) {
    try {
      await firstValueFrom(store.dispatch(new FetchShops()));
      active = store.selectSnapshot(ShopState.activeShop);
    } catch {
      return deny();
    }
  }

  return isVatEligibleRegion(active?.region) ? true : deny();
};
